import Mixpanel from "mixpanel-browser";

const isDev = process.env.NODE_ENV === "development";
const token = process.env.REACT_APP_COLLECTORS_MIXPANEL_TOKEN || "collectors-dev";

Mixpanel.init(token, {
  api_host: "https://api-eu.mixpanel.com",
  ignore_dnt: true,
});
Mixpanel.register_once({ app: "collectors" });

if (isDev) {
  console.log("[Collectors Mixpanel] init", {
    token: token === "collectors-dev" ? token : `${token.slice(0, 8)}...`,
    tokenFromEnv: Boolean(process.env.REACT_APP_COLLECTORS_MIXPANEL_TOKEN),
  });
}

export function track(eventName, properties = {}) {
  if (isDev) {
    console.log("[Collectors Mixpanel] track", eventName, properties);
  }
  Mixpanel.track(eventName, properties);
}

export function trackPageView(pathname) {
  track("Page View", { path: pathname, pathname });
}

export function getUTMParameters() {
  const utmParams = ["utm_source", "utm_campaign", "utm_medium", "utm_term", "utm_content"];
  const queryParams = new URLSearchParams(window.location.search);
  const params = {};
  utmParams.forEach((param) => {
    const value = queryParams.get(param);
    if (value) params[param] = value;
  });
  return params;
}

export function registerOnce(properties) {
  Mixpanel.register_once(properties);
}
